import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { DataService } from './services/data.service';
import { SupabaseService } from './services/supabase.service';
import { TenantService } from './services/tenant.service';
import { User } from '@supabase/supabase-js';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  user: User;
  constructor(
    private platform: Platform,
    private tenantService: TenantService,

    private sb: SupabaseService,
    private dataService: DataService,
    private router: Router
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(async (plat) => {
      this.sb._currentUser.subscribe(async (user: User) => {
        this.user = user;
        if (user) {
          console.log('user=>', user);

          if (user?.email === 'drnmchirwa@gmail.com') {
            this.router.navigate(['/notallowed']);
          }

          //only if the user has changed

          const { data } = await this.sb.supabaseClient
            .from('users')
            .select('roles, name, surname')
            .eq('id', user.id)
            .single();

          if (data) {
            console.log('data=>', data);
            this.dataService.setRoles(data.roles);
            this.dataService.setUserName(data.name + ' ' + data.surname);

            this.tenantService.getTenant();
          }
        }
      });
    });
  }

  /** check if a token (seconds) has expired,
   * first convert to date and then compare dates
   */
  isTokenExpired(expiresAt: number): boolean {
    const expiresAtDate = new Date(expiresAt * 1000);
    const now = new Date();
    return now > expiresAtDate;
  }

  changeColor(color: string) {
    document.documentElement.style.setProperty('--ion-color-primary', color);
    const rgb = this.toRgbTriplet(color);
    if (rgb) {
      document.documentElement.style.setProperty(
        '--ion-color-primary-rgb',
        rgb
      );
    }
  }

  /** "#5abb4e" | "#abc" -> "90, 187, 78" (null if unparseable) */
  private toRgbTriplet(hex: string): string | null {
    if (!hex) {
      return null;
    }
    let h = hex.trim().replace('#', '');
    if (h.length === 3) {
      h = h
        .split('')
        .map((c) => c + c)
        .join('');
    }
    if (h.length !== 6) {
      return null;
    }
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    if ([r, g, b].some((n) => isNaN(n))) {
      return null;
    }
    return `${r}, ${g}, ${b}`;
  }
}
